<template>
	<section id="user" class="slideDown" >

    <div class="container">
      <div class="content">

        <h3 class="title"><span>{{ $t("views.account.title") }}</span></h3>

        <div class="details">

          <div class="subtitle">{{ $t("views.account.subtitle") }}</div>
          <v-form ref="form_user" v-model="valid">
            <div class="alert">{{ $t("views.account.alert") }}</div>

              <v-text-field v-model="user.name" :rules="nameRules" :label="$t('general.name')" required></v-text-field>
              <v-text-field v-model="user.email" :rules="emailRules" disabled :label="$t('general.email')" required></v-text-field>
              <!-- <v-text-field v-model="user.username" :rules="nameRules" label="Nombre de usuario" required></v-text-field> -->
              <v-text-field v-model="user.phone" :rules="phoneRules" :label="$t('general.phone')"></v-text-field>
              
              <!-- <v-text-field v-model="newpassword" :type="'password'" label="Definir una nueva contraseña"></v-text-field> -->
          </v-form>

        </div>

        <div class="buttons">
          <v-btn color="success" @click="save">{{ $t("general.save") }}</v-btn>
          <div v-show="saved!=false" class="message success fadeIn" style="text-align: center;">{{saved}}</div>
        </div>

      </div>
    </div>
   
	</section>
</template>

<script>
import i18n from "@/i18n";

export default {
  props: {},
  data () {
    return {
      saved: false,
      user: JSON.parse( JSON.stringify( this.$store.getters['user/getUser'] ) ),
      valid: false,
      newpassword: "",
      nameRules: [
                    v => !!v || i18n.t("general.obligatory_name")
                  ],
      phoneRules: [
                    v => v.trim() == '' || v.replace( / /g, '' ) == parseInt( v.replace( / /g, '' ) ) || i18n.t("views.account.obligatory_phone")
                  ],
      emailRules: [
                    v => !!v || i18n.t("general.obligatory_email"),
                    v => new RegExp("[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@es.mcd.com").test(v) || i18n.t("general.obligatory_email_domain")
                  ],
      headers: [
          { text: i18n.t("general.name"), value: "name" },
          { text: i18n.t("general.region"), value: "region" },
      ],
      search: "",
      id: -1,
      message_not_found: i18n.t("views.account.message_not_found"),
      message_rows_per_page: i18n.t("views.account.message_rows_per_page"),
      rowsPerPage: [
                        5,
                        10,
                    ],
      pagination: {
        sortBy: false,
        descending: true
      },
    }
  },
  created() {
  },
  computed: {
      restaurants(){
          var restaurants = JSON.parse( JSON.stringify( ObjectToArray( this.$store.getters['locations/getLocations'] ) ) );
          var self = this;
          console.log( this.user.locations );
          restaurants.sort(function(a,b) {
            function existRestaurant( locations, restaurant ){
              var bFound = false;
              locations.forEach( location => {
                if( location.id == restaurant.id ) {
                  console.log("EXIST");
                  bFound = true;
                }
              });

              return bFound;
            }

            if( existRestaurant( self.user.locations, a ) && !existRestaurant( self.user.locations, b ) ) return -1;
            else if ( existRestaurant( self.user.locations, b ) ) return 1;
            else return 0;
          });
          return restaurants;
      },
      regions(){
        return this.$store.getters['locations/getRegions'];
      },
      selected: {
        get: function(){
            return this.user.locations;
        },
        set: function( location ){
          console.log( location );
          this.user.locations = location;
        }
      }
  },
  methods: {
    toggleAll () {
      if (this.selected.length) this.selected = []
      else {
        var restaurants = this.restaurants;
        this.selected = restaurants.slice();
      }
    },
    changeSort (column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.sortBy = column
        this.pagination.descending = false
      }
    },
    save() {
      if( this.$refs.form_user.validate() ){
          var self = this;
          if (this.newpassword!=""){
            this.user.password =  sha256(this.newpassword);            
          }
          this.user.locations = ObjectToArray(this.$store.getters['locations/getLocations']);
          this.user.active = true;
          this.$store.dispatch( 'user/uploadUser', this.user ).then( function(){
              self.saved = i18n.t("views.account.save");
              setTimeout(function(){ self.saved = false; }, 3000);
          });
      }
    },
  }
  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

  #file {
    max-width: 1200px;
    margin: 0 auto;
    margin-bottom: 50px;
  }

  .back {
    background: url(/img/left-arrow.svg) no-repeat left center;
    text-align: left;
    margin-bottom: 20px;
    padding-left: 25px;
    cursor: pointer;
  }

  .alert {
    background: #dff0f1;
    padding: 15px;
    margin: 15px 0;
    color: #5a6873;
  }

  .container {
    width: 100%;
    overflow: hidden;

    .image {
      width: 40%;
      float: left;
      padding: 0 40px;

      img {
        width: 95%;
      }
    }

    .content {
      width: 100%;
      float: left;
      text-align: left;
      padding: 0 25px;

      .title {
        margin: 10px 0;
        font-size: 20pt;
        font-family: Speedee-Bold;
      }
      .details {
        margin: 20px 0;

        .subtitle {
          font-family: Speedee-Bold;
          color: #bbb;
          margin-bottom: 10px;
        }
        .item {
          font-size: 11pt;

          .label {
            margin-right: 5px;
          }
          .value {
            font-family: Speedee-Bold;
          }
        }
      }

      .buttons {
        margin: 35px 0;

        .bttn{
          width: 100%;
          max-width: 300px;
          overflow: hidden;
          margin-bottom: 5px;
          line-height: 30px;
          cursor: pointer;
          display: block;
          color: #333;

          .icon {
            width: 30px;
            height: 30px;
            background: #ccc;
            display: inline-block;
            float: left;
            overflow: hidden;
          }
          span {
            display: inline-block;
            float: left;
            padding-left: 5px;
            font-size: 11pt;

              &:hover {
                font-family: Speedee-Bold;
              }
          }
          &.download{
            border-top: 2px solid var(--main_color);

            .icon {
              background: url(/img/download.svg) no-repeat center var(--main_color);
              background-size: 18px;
            }
          }
          &.order{
            border-top: 2px solid #ccc;
            .icon {
              background: url(/img/edit.svg) no-repeat center #ccc;
              background-size: 18px;
            }

          }
        }

      }
      .desc {
        font-size: 10pt;
        margin-top: 25px;
        margin-bottom: 5px;
        display: block;
      }
      .url {
        width: 100%;
        padding: 5px;
        font-size: 11pt;
        border-radius: 5px;
        border: 1px solid #ccc;
      }
    }
  }

</style>

